import { Card, CardContent,
     Typography, Popper, 
     Fade,
     Paper,
     IconButton,
     Link,
     Chip,
     Grid,
    Button} from "@mui/material";
import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import { format } from 'date-fns';
import { CopyButton } from "@components/object/CopyButton";

interface Props {
    evento: Evento
}

const PopupEvento: React.FC<Props> = ({evento}) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [open, setOpen] = React.useState(false);
    

  const handleClick =
    
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen((prev) => !prev);
   
    };

    return (
      <>
        <IconButton onClick={handleClick} >
          <InfoIcon />
        </IconButton>
      <Popper
        // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
        sx={{ zIndex: 1200 }}
        open={open}
        anchorEl={anchorEl}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={{ p: 2 }} >

              <Typography variant="h6">
                <b>Dettagli Evento su Microsoft Teams</b>
              </Typography>

              <Grid sx={{p: 2}}>
                  <Typography variant="body2">
                    <Link href={evento.link}>Link all'Evento </Link>
                    <CopyButton textToCopy={evento.link} />
                  </Typography>
                  <Typography variant="body2">
                    Data Evento: <b>{format(new Date(evento.data), 'dd/MM/yyyy HH:mm')}</b>
                  </Typography>
              </Grid>
            </Paper>
          </Fade>
        )}
      </Popper>
      </>
    );
}

export default PopupEvento;